import { DateTime } from 'luxon'

// Internal date formats - not exported to encourage use of specific functions
const DATE_FORMATS = {
  // Date only formats
  DATE_SHORT: 'dd/MM/yyyy', // 17/07/2025
  DATE_MEDIUM: 'dd MMM yyyy', // 17 Jul 2025
  DATE_LONG: 'DDDD', // Thursday, July 17, 2025
  DATE_ISO: 'yyyy-MM-dd', // 2025-07-17

  // Date with time formats
  DATETIME_SHORT: 'dd/MM/yyyy HH:mm', // 17/07/2025 14:30
  DATETIME_MEDIUM: 'dd MMM yyyy, HH:mm', // 17 Jul 2025, 14:30
  DATETIME_LONG: 'DDDD, HH:mm', // Thursday, July 17, 2025, 14:30
  DATETIME_ISO: 'yyyy-MM-dd HH:mm', // 2025-07-17 14:30

  // Time only formats
  TIME_SHORT: 'HH:mm', // 14:30
  TIME_MEDIUM: 'HH:mm:ss', // 14:30:45
  TIME_12H: 'h:mm a', // 2:30 PM

  // Relative formats
  RELATIVE_SHORT: 'dd tt', // 17 Jul 2:30 PM

  // Default Luxon formats
  LUXON_FULL: 'ff', // Aug 6, 2014, 1:07 PM
  LUXON_DATETIME_MED: 'FFF', // Aug 6, 2014, 1:07 PM EDT
}

// Core date formatting function
export default function useDateFormat(dateString: string, format: string = DATE_FORMATS.LUXON_FULL): string {
  const log = useLogger('composable:useDateFormat')
  if (!dateString) {
    return ''
  }

  try {
    let dateTime = DateTime.fromISO(dateString)

    // If ISO parsing fails, try parsing as JavaScript Date.toString() format
    if (!dateTime.isValid) {
      dateTime = DateTime.fromJSDate(new Date(dateString))
    }

    // If that also fails, try other common formats
    if (!dateTime.isValid) {
      // Try RFC2822 format (includes timezone names)
      dateTime = DateTime.fromRFC2822(dateString)
    }

    if (!dateTime.isValid) {
      console.warn(`Invalid date string: ${dateString}`)
      return ''
    }

    return dateTime.toLocal().setLocale(useNuxtApp().$i18n.locale.value).toFormat(format)
  }
  catch (error) {
    log.error('Error formatting date:', error)
    return ''
  }
}

// Note: Specific date formatting functions are now available as individual auto-imported composables:
// useDateShort, useDateMedium, useDateTimeISO, useDateTimeMedium, useTimeShort, etc.
